import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { SnackbarData } from '../../../model';
import { Store } from '@ngxs/store';
import { CloseSnackbar } from '../../state';

@Component({
  selector: 'app-message-box',
  templateUrl: './message-box.component.html',
  styleUrl: './message-box.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class MessageBoxComponent {
  private readonly store = inject(Store);
  readonly data = inject<SnackbarData>(MAT_SNACK_BAR_DATA);
  private readonly snackBarRef = inject<MatSnackBarRef<MessageBoxComponent>>(MatSnackBarRef);

  onCloseButtonClick(): void {
    this.snackBarRef.dismiss();
  }

  onActionButtonClick(): void {
    this.store.dispatch([new CloseSnackbar(), this.data.actionProps.confirmActionClass]);
  }
}
